import { __extends } from "tslib";
import { deserializeAws_json1_1ListFacesCommand, serializeAws_json1_1ListFacesCommand } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var ListFacesCommand = /** @class */ (function (_super) {
    __extends(ListFacesCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListFacesCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    ListFacesCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListFacesCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1ListFacesCommand(input, context);
    };
    ListFacesCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1ListFacesCommand(output, context);
    };
    return ListFacesCommand;
}($Command));
export { ListFacesCommand };
//# sourceMappingURL=ListFacesCommand.js.map